import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';
import 'font-awesome/css/font-awesome.min.css';
import './index.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import App from './components/containers/App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import LoadingBar from './components/shared/EclipseLoading.js';
import GlobalState from './components/containers/GlobalState.js';
// import OfflineChecker from './components/shared/OfflineChecker.js';
// import { Offline, Online,  } from "react-detect-offline";
const LazyDashboard = React.lazy(() => import("./components/containers/Dashboard.js"));


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
   {/* <OfflineChecker /> */}
    <GlobalState>
      <Routes>
        <Route path="/dashboard/*"
          element={
            <React.Suspense fallback={
              <section style={{
                height: '80vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
              >
                <LoadingBar classNames={`ldio-text-danger`} />
              </section>
            }>
              <LazyDashboard />
            </React.Suspense>
          }
        />
        <Route path="*" element={<App />} />
      </Routes>
      <Toaster containerStyle={{ direction: 'rtl', textAlign: 'right', fontSize: '.9rem' }} />
    </GlobalState>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
